import _get from 'lodash/get';
import { setAttributes } from '../logic/analytics/analytics.utils';
import {
  getElapsedTimeInSeconds,
  getIsLive,
  getPlaybackState,
  getStartTimeInSeconds,
} from '../logic/player/player.selectors';
import {
  INITIALIZED,
  PLAYING,
  PAUSED,
  TIME_UPDATE,
  SEEKING,
  SEEKED,
  RESET,
  reset,
  PLAYBACK_STATE_PLAYING,
} from '../logic/player/player.constants';
import { Heartbeat } from '../modules/heartbeat';
import { showPopupAction } from '../logic/popup/popup.actions';
import { CSL_BLOCK_POPUP_ID } from '../modules/popups/popups.constants';
import { getHeartbeatV2 } from '../logic/heartbeat/heartbeat.selectors';

// TODO: Figure out what is expected in case of Heartbeat CSL error after deeplink
const cslErrorHandler = dispatch => () => {
  dispatch(showPopupAction(CSL_BLOCK_POPUP_ID, {}));
  dispatch(reset());
};

export default ({ getState, dispatch }) =>
  next =>
  action => {
    const forward = next(action);

    switch (action.type) {
      case INITIALIZED: {
        const state = getState();
        const analyticsFromLayout = getHeartbeatV2(state);

        Heartbeat.createSession({
          ...analyticsFromLayout,
          startTime: getIsLive(state) ? getStartTimeInSeconds(state) : getElapsedTimeInSeconds(state),
          cslErrorHandler: cslErrorHandler(dispatch),
        }).then(sessionId => {
          if (sessionId) {
            setAttributes({ heartbeatSessionId: sessionId });
          }
        });
        break;
      }
      case PLAYING: {
        Heartbeat.resume();
        break;
      }
      case PAUSED: {
        Heartbeat.pause();
        break;
      }
      case TIME_UPDATE: {
        Heartbeat.currentPlayerTime = getElapsedTimeInSeconds(getState());

        break;
      }
      case SEEKING: {
        const from = _get(action, 'payload.from');
        if (Number.isFinite(from)) {
          Heartbeat.currentPlayerTime = from;

          // Stopping heartbeats since seek may take significant time due to buffering
          Heartbeat.pause();
        }
        break;
      }
      case SEEKED: {
        const state = getState();
        const playbackState = getPlaybackState(state);

        // Using current time as a fallback in case if something went wrong with seek event
        Heartbeat.currentPlayerTime = getIsLive(state)
          ? getElapsedTimeInSeconds(state)
          : _get(action, 'payload.to', getElapsedTimeInSeconds(state));

        const from = _get(action, 'payload.from');
        if (!Number.isFinite(from)) {
          break;
        }

        // PLAYING event will be issued anyway after SEEKED, no need to duplicate it
        if (playbackState !== PLAYBACK_STATE_PLAYING) {
          Heartbeat.pause();
        }

        break;
      }
      case RESET: {
        Heartbeat.destroy();
        break;
      }
      default:
        break;
    }

    return forward;
  };
